import { useContext } from 'react';
import { RequestsContext } from '../context/RequestsContextObject';

export const useRequests = () => {
  const context = useContext(RequestsContext);
  if (!context) {
    throw new Error('useRequests must be used within a RequestDataProvider');
  }

  return context;
};
